import { XIcon } from '@heroicons/react/outline'
import React from 'react'

function DetailContentBox({ view,onClose,component }) {
    return (
        <>
            <div className='detailContentBox bg-white shadow-lg rounded-md p-4'>
                <div className='detailContentBox-container'>
                    <div className='detailContentBox-header pb-1 flex justify-between items-center border-b border-gray-300'>
                        <p className=' capitalize font-bold text-gray-700 manpro text-lg mb-0'>{view}</p>
                        <div className='w-6 cursor-pointer' onClick={onClose}>
                            <XIcon className='w-full' />
                        </div>
                    </div>
                    <div className='pt-1 max-h-96 overflow-y-auto'>
                        {component}
                    </div>
                </div>
            </div>
        </>
    )
}

export default DetailContentBox